/**
 * Drop-in replacement for redux-form's SubmissionError.
 * Thrown by store thunks when a form submission fails with server-side validation errors.
 */
export class FormSubmissionError extends Error {
  errors: Record<string, unknown>;

  constructor(errors: Record<string, unknown>) {
    super('Form submission failed');
    this.name = 'FormSubmissionError';
    this.errors = errors;
  }
}
